<template>
  <div id="app">
    <Header></Header>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
  }
}
</script>

<style>
  #app {
    font-family: PingFang SC, Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  @media screen and (min-width: 576px) {
    #app {
      font-size: 16px;
    }
  }
  @media screen and (max-width: 575px) {
    #app {
      font-size: 14px;
    }
  }
  *, body {
    padding: 0;
    margin: 0;
  }
  ul, li {
    list-style: none;
  }
  a {
    text-decoration: none;
  }
</style>
